import React from "react";
import Helmet from "react-helmet";
import FormResumen from "../../components/paet/FormResumen";

export default function Resumen() {
    return (
        <>
            <Helmet>
                <title>Retiro Enfermos Terminales AFP Modelo | Solicitud de Retiro Enfermos Terminales | AFP Modelo</title>
                <meta name="description" content={``} />
                <meta name="robots" content="noindex, follow" />
            </Helmet>
            <section>
                <div className="container">                   
                    <div className="card formulario mt-5 mb-5">
                        <div className="card-header">
                            <div className="form-row">
                                <div className="titulo">
                                    Retiro de Pensión Anticipada por Enfermedad Terminal (PAET)
                                </div>
                            </div>
                            <div className="form-row">
                                <div className="subtitulo mt-3">
                                    Resumen de tu solicitud:
                                </div>
                            </div>
                        </div>
                        <div className="card-body paet">
                            <FormResumen />
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}